import { useMemo } from "react";

import { useCategories } from "~/providers/CategoriesProvider";
import type { IOption } from "~/types/option";

export const useCategoryFilterDropdownOptions = (): IOption[] => {
  const { categories } = useCategories();
  return useMemo(
    () =>
      categories.map(
        (category): IOption => ({
          label: category.name,
          value: category.id,
        })
      ),
    [categories]
  );
};
